module.exports = __webpack_public_path__ + "static/media/Resume_JFM_EN.49a1d5d4.pdf";